<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconGeneric2_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M8 15a6.8 6.8 0 0 1-2.73-.551 7.1 7.1 0 0 1-2.222-1.496A7.1 7.1 0 0 1 1.55 10.73 6.8 6.8 0 0 1 1 8q0-1.452.551-2.73a7.1 7.1 0 0 1 1.497-2.222A7.1 7.1 0 0 1 5.27 1.55 6.8 6.8 0 0 1 8 1q1.452 0 2.73.551a7.1 7.1 0 0 1 2.223 1.497q.944.945 1.496 2.222.55 1.278.551 2.73v1.015q0 1.033-.709 1.759a2.34 2.34 0 0 1-1.741.726q-.612 0-1.155-.262a2.47 2.47 0 0 1-.91-.753 3.4 3.4 0 0 1-1.146.761Q8.7 11.501 8 11.5a3.37 3.37 0 0 1-2.476-1.024A3.37 3.37 0 0 1 4.5 8q0-1.453 1.024-2.476A3.37 3.37 0 0 1 8 4.5q1.453 0 2.476 1.024A3.37 3.37 0 0 1 11.5 8v1.015q0 .455.297.77a1 1 0 0 0 .753.315 1 1 0 0 0 .752-.315 1.08 1.08 0 0 0 .298-.77V8q0-2.344-1.627-3.972Q10.344 2.4 8 2.4T4.028 4.028 2.4 8q0 2.344 1.628 3.973Q5.655 13.6 8 13.6h4.2s.7 0 .7.7-.7.7-.7.7zm0-4.9q.875 0 1.488-.612Q10.1 8.874 10.1 8q0-.876-.612-1.487A2.03 2.03 0 0 0 8 5.9q-.876 0-1.487.612A2.03 2.03 0 0 0 5.9 8q0 .875.612 1.488.613.612 1.488.612"
    />
</svg>
